import { formatDistanceToNow, Locale } from 'date-fns';

export const getTimeAgo = (date: Date, locale: Locale): string => {
  return formatDistanceToNow(date, { addSuffix: true, locale });
};
